export const filters = [
  {
    label: 'mostFunded',
    name: 'Most Funded',
  },
  {
    label: 'closingSoon',
    name: 'Closing Soon',
  },
  {
    label: 'recentlyLaunched',
    name: 'Newest',
  },
  {
    label: 'mostMomentum',
    name: 'Most Momentum',
  },
];

// order matters
export const errorTexts = [
  'Please enter a valid first name to continue.',
  'Please enter a valid last name to continue.',
  'Please enter a valid work email to continue.',
  'Please enter a valid phone number to continue.',
  `Oh! It looks like the email you entered is not quite valid. Please update to continue.`,
  'It looks like you have entered a non-work email. Please use only work email addresses.',
  // Start of second set of questions
  'Please enter a valid company name to continue.',
  `It seems like you haven't added your website yet. Just drop it in the box above, and then we can keep things rolling!`,
  'It looks like you have not selected if you are incorporated in the US. Please click one of the yes or no buttons.',
  `It seems like you haven't selected if your executive team is based in the US. Please click one of the yes or no buttons.`,
  // Start of final set of quesitons
  'Before you submit could you let us know why you would be a good fit in the text field above.',
];

export const nonValidWorkEmails = [
  'gmail.com',
  'yahoo.com',
  'aol.com',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'mail.com',
  'yandex.com',
  'zoho.com',
  'protonmail.com',
  'gmx.com',
  'gmx.net',
  'gmx.us',
  'inbox.com',
  'rocketmail.com',
  'fastmail.com',
  'hushmail.com',
  'lycos.com',
  'excite.com',
  'rediffmail.com',
  'web.de',
  't-online.de',
  'freenet.de',
  'yahoo.co.uk',
  'yahoo.co.in',
  'yahoo.fr',
  'hotmail.co.uk',
  'hotmail.fr',
];

export const raiseCapitalImageList = [
  {
    background:
      'https://d3to30xgiunr31.cloudfront.net/images/raise-capital/thumbnail-493749837.png',
    person: 'https://d3to30xgiunr31.cloudfront.net/images/raise-capital/Ellipse-4619-2.png',
    amountRaised: '$35M Raised',
    quote:
      '“After we started [our first] raise, we ended up getting an order … It was for 156 houses, so about nine-and-a-half million dollars”',
    quoteBy: '—Boxabl CEO Galiona Tiramani',
  },
  {
    background: 'https://d3to30xgiunr31.cloudfront.net/images/raise-capital/Rectangle-2227.png',
    person: 'https://d3to30xgiunr31.cloudfront.net/images/raise-capital/Ellipse-4619-1.png',
    amountRaised: '$9M Raised',
    quote:
      '“I compared the different platforms that were available, and I found that StartEngine was the most entrepreneur friendly.”',
    quoteBy: '—Flower Turbines CEO Dan Farbman',
  },
  {
    background: 'https://d3to30xgiunr31.cloudfront.net/images/raise-capital/Rectangle-2227-1.png',
    person: 'https://d3to30xgiunr31.cloudfront.net/images/raise-capital/Ellipse-4619-3.png',
    amountRaised: '$2M Raised',
    quote:
      '“The most we had ever done [was] 64 barrels in a year … Now we’re on track to do 300 barrels a year … And that’s due to crowdfunding”',
    quoteBy: '—Copperworks Distilling CEO Jason Parker',
  },
];
